export var E_USER_MODAL;
(function (E_USER_MODAL) {
    E_USER_MODAL[E_USER_MODAL["USER_DETAILS"] = 0] = "USER_DETAILS";
    E_USER_MODAL[E_USER_MODAL["DELETE_USER"] = 1] = "DELETE_USER";
    E_USER_MODAL[E_USER_MODAL["IMPORT_USER"] = 2] = "IMPORT_USER";
})(E_USER_MODAL || (E_USER_MODAL = {}));
